export default __webpack_public_path__ + "static/media/original.35d5e6fc.png";